module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty19.7ada49e6.jpg";